import { PropsWithChildren } from "react";
import { usePopover } from "../../../store/onboarding/onboardingSlice";
import { ClickButton } from "../../../components/Buttons";

const HubPopover: React.FC<PropsWithChildren> = ({ children }) => {
    const { popoverData, displayPopover, nextPopover, Popover } = usePopover("cloud-hosted-hub");

    return (
        <Popover
            title={popoverData?.title as string}
            text={popoverData?.text as string}
            position={popoverData?.position as PositionProps}
            content={
                <ClickButton variant="primary" text="Next" onClick={() => {
                    nextPopover();
                }} />
            }
            counter={3}
            display={displayPopover}
        >
            {children}
        </Popover>
    );
};

export default HubPopover;
